import lottie from "lottie-web";
import React, { useEffect, useRef } from "react";
import styles from "./VideoLoading.module.scss";
import loader from "./assets/videoLoader.json";
export function VideoLoading() {
  var lottieRef = useRef(null);
  var animationRef = useRef(null);
  useEffect(function () {
    if (lottieRef.current) {
      animationRef.current = lottie.loadAnimation({
        animationData: loader,
        container: lottieRef.current
      });
      return function () {
        var _animationRef$current;
        (_animationRef$current = animationRef.current) === null || _animationRef$current === void 0 || _animationRef$current.destroy();
      };
    }
  }, [lottieRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loadingWrapper
  }, /*#__PURE__*/React.createElement("div", {
    ref: lottieRef,
    className: styles.lottieLoader
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.loadingText
  }, "Generating video"));
}